var ajaxdelay = 1; var active_connection = 0;
$( document ).ready(function() {

  function Ajax(){
      this.element = null;
      this.xhr;
      this.waiting = false;
      this.showeffect = true;
      this.started = null;
      this.params = {
          'type':'form',
          'data':{},
          'onSuccess': {}
      };
      this.done = function() {};
      this.send = function() {
          active_connection += 1;
          var data = new Object();
          var action = "";
          data = {
              data : {}
          };
          data.data = this.params.data;
          switch(this.params.type){
              case "component":
                  data.parts = $(this.element).attr('id').split(' ');
                  data.targets = $(this.element).attr('id').split(' ');
                  data.data.component = $(this.element).attr('id');
                  action = "/component/refresh";
                  break;
              case "form":
                  data.parts = $(this.element).attr('ajaxparts').split(' ');
                  data.targets = $(this.element).attr('ajaxtargets').split(' ');
                  action = $(this.element).attr('action');
                  break;
              case "input":
                  data.parts = $(this.element).attr('ajaxparts').split(' ');
                  data.targets = $(this.element).attr('ajaxtargets').split(' ');
                  action = $(this.element).attr('ajaxaction');
                  break;
              case "linkaction":
                  data.parts = $(this.element).attr('ajaxparts').split(' ');
                  data.targets = $(this.element).attr('ajaxtargets').split(' ');
                  action = $(this.element).attr('href');
                  break;
              case "componentAction":
                  break;
          }
          if(this.showeffect) $(data.targets).each(function(key,value){
               $('#'+value).addClass('ajaxloading');
               $('#'+value).find('.divsvg').remove();
               var object = $('<object type="image/svg+xml" data="/loader.svg"></object>');
                var div = $('<div class="divsvg"></div>');
                div.append(object);
                $('#'+value).prepend(div);

          });
          if(typeof action == 'undefined') action = location.pathname+(location.search?location.search:"");
              action = action + ( action.indexOf('?') !== -1 ? '&chromb' : '?chromb');

          $(this.element).find(":input").each(function(){
              if(typeof $(this).attr('name') !== 'undefined') {
                  if($(this).is( ":button" ) && !$(this).hasClass('clicked')) {  }
                  else if($(this).is( "input[type=submit]" ) && !$(this).hasClass('clicked')) {  }
                  else if($(this).is( ":checkbox" ) && !$(this).prop("checked")) {  }
                  else if($(this).is( ":radio" ) && !$(this).prop("checked")) {  }
                  else if($(this).attr('name').match(/([a-zA-Z0-9]*)\[([a-zA-Z0-9]*)\]/gi)){
                      var result = $(this).attr('name').match(/([a-zA-Z0-9]*)\[([a-zA-Z0-9]*)\]/i);
                      if(typeof data['data'][result[1]] === "undefined" && result[2]!=="") data['data'][result[1]] = new Object();
                      else if(typeof data['data'][result[1]] === "undefined") data['data'][result[1]] = new Array();
                      if(result[2]==="") {
                          data['data'][result[1]].push($(this).val());
                      }
                      else data['data'][result[1]][result[2]] = $(this).val();
                      // toto tu bylo proč? viz git... odstraněno

                  } else if($(this).attr('name').length) data['data'][$(this).attr('name')] = $(this).val();
              } // This is the jquery object of the input, do what you will
          });

          if(this.waiting) {
              active_connection -= 1;
              clearTimeout(this.timeout);
          }

          var roll = this.params.roll;
          var rollb = this.params.rollb;
          var done = this.done;
          this.started = new Date().getTime();
            this.timeout = setTimeout(function() {
                this.waiting = false;
                if(this.xhr !== undefined && this.xhr.readyState != 4) this.xhr.abort();
                this.xhr = $.ajax( action,
                {
                    //cache: false,
                    method: 'POST',
                    headers: {
                      'X-CSRF-Token': $('meta[name="_token"]').attr('content')
                    },
                    data: JSON.stringify(data, (key, value) => {
                        if (typeof value !== "undefined" && value !== null) return value;
                        else return undefined;
                      }),
                    contentType: "application/json; charset=utf-8",
                    success: function(data){

                        $.each(data.HTMLFragments,function(key,fragment){
                            $('#'+key).removeClass('ajaxloading');
                            $('#'+key).find('.divsvg').remove();
                            if($(fragment).attr('id') !== key) fragment = $(fragment).attr('id',key);
                            if(roll !== undefined && roll){
                                $('#'+key).slideUp(800,function(){ $(this).html(''); }).attr('id','teeest').after(fragment);
                                $('#'+key).hide(0).slideDown(800);

                            } else if(rollb !== undefined && rollb) {
                                $('#'+key).slideUp(800,function(){ $(this).html(''); }).attr('id','teeest').before(fragment);
                                $('#'+key).hide(0).slideDown(800);
                            } else { $('#'+key).replaceWith(fragment);   }
                            $(fragment).attr('id',key);
                            $('#'+key).find('select').not('.noSelectInput').each(function(){
                                  global.SelectInputQueue.push(new SelectInput(this));
                              });
                            $('#'+key).find('.deferimg').each(function(){
                                  $(this).replaceWith(this.innerHTML.replace('&lt;img','<img').replace('&gt;','>'));
                              });
                              $('button').each(function (i) { $(this).attr('tabindex', -1); }); // safari aby bralo focus


                        });
                        if(data.gtmdata !== undefined) {
                            $.each(data.gtmdata,function(key,command){
                                if(typeof gtag === 'function') {
                                    gtag(command.commandType, ...command.arguments);
                                }
                            });
                        }
                        if(data.redirect !== undefined) {
                            window.location.replace(data.redirect);
                        }
                        if(data.newurl !== undefined) {
                            var pos = data.newurl.indexOf('#');
                            if(pos > 0){
                                var hash = data.newurl.substring(pos+1);
                                var target = $('#'+hash);
                                target = target.length ? target : $('[name=' + hash +']');
                                if (target.length && !$(target).isInViewport()) {
                                  $('html, body').animate({
                                    scrollTop: target.offset().top
                                  }, 1000,function(){
                                      window.history.pushState({},"", data.newurl);
                                  });
                                } ;
                            } else window.history.pushState({},"", data.newurl)

                        }
                        done();
                    },
                    dataType: "json",
                    complete: function(){
                         if(typeof data.targets !== "undefined") $(data.targets).each(function(key,value){
                            $('#'+value).removeClass('ajaxloading');
                            $('#'+value).find('.divsvg').remove();

                        });
                        active_connection -= 1;
                    }
                }
                );
            },ajaxdelay);
            ajaxdelay = 1;
      };
  }


window.onpopstate = function (e){
    if(e.state) window.location.reload();
};

$(document).ajaxStart(function(){
    if($('#ajaxOverlay').length === 0) {
        var div = $('<div id="ajaxOverlay"><div class="ao-bar"><div class="ao-active"></div></div></div>');
         $('body').append(div);
    $('#ajaxOverlay .ao-active').animate( {width: '80%'} , 4000, "swing" , function () {  $('#ajaxOverlay .ao-active').animate( {width: '85%'} , 10000, "linear" ); });
    }

});

$(document).ajaxStop(function(){
    working_reset(1);
});

$(window).bind('beforeunload', function(){
            if($('#ajaxOverlay').length === 0) {
        var div = $('<div id="ajaxOverlay"><div class="ao-bar"><div class="ao-active"></div></div></div>');
         $('body').append(div);
    $('#ajaxOverlay .ao-active').animate( {width: '80%'} , 4000, "swing" , function () {  $('#ajaxOverlay .ao-active').animate( {width: '85%'} , 10000, "linear" ); });
    }
        });

$( document ).ajaxError(function( event, jqxhr, settings, thrownError ) {
    if(jqxhr.responseJSON !== undefined && jqxhr.responseJSON.redirect) window.location.replace(jqxhr.responseJSON.redirect);
});

var working_reset = function(reset){
    if(!active_connection)
    {
        if(typeof reset === 'undefined')
            setTimeout(function(){
                working_reset(1);
            },1000);

        else {
            $('#ajaxOverlay .ao-active').stop();
            $('#ajaxOverlay .ao-active').animate( {width: '100%'} , 200, "linear" , function () { $('#ajaxOverlay').remove(); } );
            /*$('button.clicked > div,input[type=submit].clicked > div').each(function(key,obj){
                $(obj).replaceWith($(obj).html());
            });*/
            $('button.clicked,input[type=submit].clicked').find('.divsvg').remove();
            $('button.clicked,input[type=submit].clicked').removeClass("clicked");
            $(window).scroll();
            $(window).resize();
        }
    }
}

setInterval(working_reset,1000);



    $(document).on('keyup', 'input[type=text].ajax', function (e) {
        if (e.keyCode != 27) { //kvuli evt-esc v events.js
            ajaxdelay = 350;
            if ($(this).data("Ajax") === undefined) {
                var A = new Ajax();
                if ($(this).attr('ajaxtargets') !== undefined && $(this).attr('ajaxparts') !== undefined) {
                    A.element = $(this);
                    $.extend(true, A.params, {
                        'type': 'input',
                    });
                }
                else {
                    A.element = $(this).closest('form');
                }
                $(this).data("Ajax", A);
            }
            if ($(this).attr('ajaxtargets') !== undefined && $(this).attr('ajaxparts') !== undefined) {
                var data = new Object();
                data[$(this).attr('name')] = $(this).val();
                $.extend(true, $(this).data("Ajax").params, {
                    'data': data
                });
            }
            e.preventDefault();
            $(this).data("Ajax").send();
        }
    });


    $(document).on('submit','form.ajax',function(e){
        if($(this).data("Ajax") === undefined){
            var A = new Ajax();
            A.element = this;
            if($(this).attr('ajaxparts').includes('component-Models-TaxDocuments-Basket-1')) {
                var _this = $(this);
                A.done = function(){
                    $('.dropdown-menu--basket').addClass('active');
                    setTimeout(function(){
                        $('.dropdown-menu--basket').removeClass('active');
                    }, 3000);
                    $(window).scroll();

                    if(typeof gtagOld === 'function') {
                        gtagOld("event", "add_to_cart", {
                            currency: _this.find('input[name=currency]').val(),
                            value: _this.find('input[name=price]').val() * _this.find('input[name=amount]').val(),
                            items: [
                                {
                                    item_id: _this.find('input[name=id]').val(),
                                    item_name: _this.find('input[name=name]').val(),
                                    price: _this.find('input[name=price]').val(),
                                    quantity: _this.find('input[name=amount]').val()
                                }
                            ]
                        });
                    }
                }
            }
            $(this).data("Ajax",A);
        }
        e.preventDefault();
        var buttons = $(this).find('button:focus,input[type=submit]:focus,button.clicked,input[type=submit].clicked');
        if(buttons.length) {

            if(!buttons.hasClass('checkbox')) $(this).data("Ajax").showeffect = false;
            buttons.each(function(e){
                $(this).addClass("clicked");
                $(this).find('.divsvg').remove();
                var object = $('<object type="image/svg+xml" data="/loader.svg"></object>');
                var div = $('<div class="divsvg"></div>');
                div.append(object);
                $(this).prepend(div);
                //$(this).html('<div>'+$(this).html()+'</div>');
            });
        }

        $(this).data("Ajax").send();
    });

    $(document).on('change', 'input.ajaxchange, select.ajaxchange, textarea.ajaxchange', function (e) {
        if ($(this).data("Ajax") === undefined || $(this).hasClass('ajaxchangefresh')) {
            var A = new Ajax();
            A.element = $(this).parents('form').first();
            $(this).data("Ajax", A);
            if (this.tagName != "SELECT" && $(this).attr('type') !== "number")
                A.showeffect = false;
        }
        e.preventDefault();
        $(this).data("Ajax").send();
    });

    $(document).on('change','input.xhrchange,select.xhrchange',function(e){
        if($(this).data("Ajax") === undefined){
            var A = new Ajax();
            A.element = $(this).parents('form').first();
            $(this).data("Ajax",A);
        }
        e.preventDefault();
        $(this).data("Ajax").send();
    });

      $(document).on('mouseenter','.component-reload-hover',function(e){
          if($(this).data("Ajax") === undefined){
            var A = new Ajax();
            A.element = $(this).closest('.component');
            $.extend(true,A.params,{
                'type':'component',
                'data': $.parseJSON($(this).attr('value').replace(/\'/g,'"'))
            });
            $(this).data("Ajax",A);
          }
          e.preventDefault();
          $(this).data("Ajax").send();
      });

      $(document).on('click','.component-reload-click',function(e){
          if($(this).data("Ajax") === undefined){
            var A = new Ajax();
            A.element = $(this).closest('.component');
            $.extend(true,A.params,{
                'type':'component',
                'data': $.parseJSON($(this).attr('value').replace(/\'/g,'"'))
            });
            if($(this).hasClass('roll')) $.extend(true,A.params,{
                'roll': true
            });
            else if($(this).hasClass('rollb')) $.extend(true,A.params,{
                'rollb': true
            });
            $(this).data("Ajax",A);
          }
          e.preventDefault();
          $(this).data("Ajax").send();
      });

      $(document).on('click','.brand-link',function(e){
          e.preventDefault();
      });

      $(document).on('click','a.ajax',function(e){
          if($(this).data("Ajax") === undefined){
            var A = new Ajax();
            A.element = this;
            $.extend(true,A.params,{
                'type':'linkaction'
            });
            $(this).data("Ajax",A);
        }
        e.preventDefault();
        $(this).data("Ajax").send();
      });

      $('button').each(function (i) { $(this).attr('tabindex', -1); }); // safari aby bralo focus
      $(document).on('mouseup','button',function(e){
          $(this).addClass("clicked");
        e.preventDefault();
      });

});
